<div class="banner-info-container">
  <div class="container">
    <div class="pt-5" >
      <h1 class="pb-3">Instant Solar Design Assistance without Site Visits</h1>
        <img loading="lazy" src="{{environment?.blobUrl}}/assets/images/solar-design/Solar-Solution-Design.webp" alt="Solar Solution Design | Luminous" class="h-100" (load)="imageLoaded()">
    </div>
  </div>
</div>
